import React, { useEffect, useState } from "react";
import {
  Globe2,
  Activity,
  UserCheck,
  MonitorSmartphone,
  ShieldCheck,
  Cpu,
  Ambulance,
} from "lucide-react";

// Mapping icons dynamically
const iconMap = {
  Globe2,
  Activity,
  UserCheck,
  MonitorSmartphone,
  ShieldCheck,
  Cpu,
  Ambulance,
};

const WhychooseUs = () => {
  const [data, setData] = useState([]);

  // Fetch JSON from public folder
  useEffect(() => {
    fetch("/AllJson/whychooseus.json")
      .then((res) => res.json())
      .then((json) => setData(json.whyChooseUs))
      .catch((err) => console.error("Error loading WhyChooseUs data:", err));
  }, []);

  return (
    <section
      id="why-choose-us"
      aria-labelledby="why-choose-us-heading"
      className="bg-cream text-maroon-dark py-16 pt-0 px-4 sm:px-8 lg:px-16"
    >
      <div className="max-w-7xl mx-auto">
        {/* 🏷️ Accessible heading */}
        <h2
          id="why-choose-us-heading"
          className="text-3xl sm:text-4xl font-extrabold text-center text-maroon mb-12"
        >
          Why Choose Us
        </h2>

        <ul className="flex flex-wrap justify-center gap-8" role="list">
          {data.map((item, index) => {
            const Icon = iconMap[item.icon];
            return (
              <li
                key={index}
                tabIndex={0}
                aria-label={`Feature: ${item.title}`}
                className="flex flex-col items-center p-6 pt-0 bg-white rounded-2xl shadow-md border border-gold 
                   transition-transform duration-300 hover:scale-105 focus-within:scale-105 focus:outline-none 
                   w-full sm:w-[45%] lg:w-[30%]"
              >
                <div
                  className="p-3 bg-gold-light/20 rounded-full mb-4"
                  aria-hidden="true"
                >
                  {Icon && (
                    <Icon
                      size={40}
                      className="text-maroon"
                      aria-hidden="true"
                    />
                  )}
                </div>

                <h3 className="text-xl font-semibold text-center mb-2 text-maroon-dark">
                  {item.title}
                </h3>

                <p
                  className="text-center text-gray-800 leading-relaxed"
                  dangerouslySetInnerHTML={{ __html: item.description }}
                ></p>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

export default WhychooseUs;
